// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-topbar {
  min-height: 64px;
  border-bottom: 1px solid #E2E8F0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 12px 16px;
  background: #ffffff;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .home-topbar {
    min-height: 72px;
    padding: 0 20px;
    flex-wrap: nowrap;
  }
}

.home-topbar__clinic {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.home-topbar__mark {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #E0F2FE;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.home-topbar__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 768px) {
  .home-topbar__title {
    font-size: 20px;
  }
}

.home-topbar__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex-shrink: 1;
  min-width: 0;
  justify-content: flex-end;
}

@media (max-width: 640px) {
  .home-topbar__actions {
    width: 100%;
    justify-content: stretch;
  }

  .home-date-control {
    flex: 1;
    min-width: 0;
  }

  .home-topbar__cta.ant-btn {
    flex: 1;
  }

  .home-date-control__label span:not(.anticon) {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.home-topbar__cta.ant-btn {
  height: 36px !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  background: #0EA5E9 !important;
  border-color: #0EA5E9 !important;
  box-shadow: none !important;
}

.home-topbar__cta.ant-btn:hover {
  background: #0284C7 !important;
  border-color: #0284C7 !important;
}

.home-date-control {
  display: flex;
  align-items: center;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  padding: 4px;
  gap: 2px;
}

.home-date-control__nav {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #64748B;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.home-date-control__nav:hover {
  color: #0F172A;
  background: #ffffff;
}

.home-date-control__label {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #0F172A;
  white-space: nowrap;
}

.home-date-control__icon {
  color: #0EA5E9;
  font-size: 16px;
}

.home-date-control__picker.ant-picker {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
}

.home-date-control__picker .ant-picker-input {
  height: 100%;
}

.home-date-control__picker .ant-picker-input > input {
  cursor: pointer;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageHeader/DateHeader/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,OAAO;IACP,YAAY;EACd;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":[".home-topbar {\n  min-height: 64px;\n  border-bottom: 1px solid #E2E8F0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  padding: 12px 16px;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n@media (min-width: 768px) {\n  .home-topbar {\n    min-height: 72px;\n    padding: 0 20px;\n    flex-wrap: nowrap;\n  }\n}\n\n.home-topbar__clinic {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.home-topbar__mark {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #E0F2FE;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.home-topbar__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (min-width: 768px) {\n  .home-topbar__title {\n    font-size: 20px;\n  }\n}\n\n.home-topbar__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  flex-shrink: 1;\n  min-width: 0;\n  justify-content: flex-end;\n}\n\n@media (max-width: 640px) {\n  .home-topbar__actions {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .home-date-control {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .home-topbar__cta.ant-btn {\n    flex: 1;\n  }\n\n  .home-date-control__label span:not(.anticon) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.home-topbar__cta.ant-btn {\n  height: 36px !important;\n  padding: 0 16px !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  background: #0EA5E9 !important;\n  border-color: #0EA5E9 !important;\n  box-shadow: none !important;\n}\n\n.home-topbar__cta.ant-btn:hover {\n  background: #0284C7 !important;\n  border-color: #0284C7 !important;\n}\n\n.home-date-control {\n  display: flex;\n  align-items: center;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  padding: 4px;\n  gap: 2px;\n}\n\n.home-date-control__nav {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: #64748B;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.home-date-control__nav:hover {\n  color: #0F172A;\n  background: #ffffff;\n}\n\n.home-date-control__label {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0F172A;\n  white-space: nowrap;\n}\n\n.home-date-control__icon {\n  color: #0EA5E9;\n  font-size: 16px;\n}\n\n.home-date-control__picker.ant-picker {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: none;\n}\n\n.home-date-control__picker .ant-picker-input {\n  height: 100%;\n}\n\n.home-date-control__picker .ant-picker-input > input {\n  cursor: pointer;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
